<template>
  <div
    class="position-absolute"
    :class="setSemitransparent ? 'semitransparent' : ''"
    id="docRelational"
  >
    <el-tabs v-model="activeName" type="border-card" class="h-full" v-loading="treeLoading">
      <el-tab-pane label="关联对象" name="relationCode">
        <el-row :gutter="20">
          <el-col :span="14" :offset="0">
            <el-input
              v-model="docKeyWord"
              :placeholder="docPlaceholder"
              size="small"
              clearable
            ></el-input>
          </el-col>

          <el-col :span="10" :offset="0" class="tr">
            <el-button type="primary" @click="findTagClassAssociation('search')">搜索</el-button>
            <el-button type="primary" @click="addOperation()"> 添加 </el-button>
          </el-col>
        </el-row>
        <div style="height: calc(100% - 20px)" class="mt-10px">
          <el-tree
            :data="correlateTreeData"
            :props="defaultProp"
            :highlight-current="true"
            node-key="id"
            :load="loadNode"
            lazy
            ref="tree"
            :default-expanded-keys="expandedKey"
            :expand-on-click-node="false"
            @node-click="handleNodeClick"
          >
            <el-row
              class="text-12px h-full"
              slot-scope="{ node, data }"
              style="line-height: 24px; width: calc(100% - 20px)"
            >
              <el-tooltip
                effect="dark"
                :content="`${data.code}[${node.label}]`"
                placement="top"
                :open-delay="1000"
              >
                <el-col
                  class="dib text-overflow h-38px truncate"
                  :span="node.level === 2 ? 14 : 20"
                  :tagId="data.id"
                >
                  {{ data.code }}[{{ node.label }}]
                </el-col>
              </el-tooltip>
              <el-col :span="4" v-if="currentTag && currentTag.businessId === data.businessId">
                <el-tooltip content="上一个" placement="bottom" effect="light">
                  <i
                    class="iconfont icon-bg-packUp text-color-blue mr-20px"
                    @click.stop="findOne(data, 'prev')"
                  ></i>
                </el-tooltip>
                <el-tooltip content="下一个" placement="bottom" effect="light">
                  <i
                    class="iconfont icon-bg-dropDown text-color-blue"
                    @click.stop="findOne(data, 'next')"
                  ></i>
                </el-tooltip>
              </el-col>
              <el-col class="dib tr" :span="6" v-if="node.level === 2">
                <el-tooltip
                  content="解除关联关系"
                  placement="bottom"
                  effect="light"
                  :open-delay="1000"
                >
                  <i
                    class="iconfont icon-bg-unlink text-color-blue"
                    @click.stop="dissolveRelationShip(data)"
                  ></i>
                </el-tooltip>
              </el-col>
            </el-row>
          </el-tree>
        </div>
      </el-tab-pane>
      <el-tab-pane label="文档属性" name="relationCode1">
        <el-collapse v-model="activeNames">
          <el-collapse-item title="基本属性" name="1">
            <el-row
              v-for="(item, index) in tableHeader"
              :key="index"
              class="h-20px leading-14px mb-5px"
            >
              <el-col :span="7" class="text-12px font-600">{{ item.name }}：</el-col>
              <el-col :span="17" class="truncate">{{ item.value }}</el-col>
            </el-row>
          </el-collapse-item>
          <!-- <el-collapse-item v-if="attributeList" title="文档通用属性" name="2">
            <template v-for="item in attributeList">
              <p :key="item.attrId">{{ item.name }}：{{ item.value }}</p>
            </template>
          </el-collapse-item> -->
          <!-- <template v-if="templateAttrSetList">
            <el-collapse-item
              v-for="(item, index) in templateAttrSetList"
              :title="item.attributeTemplate.name"
              :key="item.attributeTemplate.id"
              :name="String(index + 3)"
            >
              <template v-for="value in item.attrValueList">
                <p :key="value.attrId">
                  {{ value.attrbuteDetail.displayName }}：{{ value.attrValue }}
                </p>
              </template>
            </el-collapse-item>
          </template> -->
        </el-collapse>
      </el-tab-pane>
      <el-tab-pane label="实现文件" name="relationCode111">
        <h3 class="font-bold text-14px">实现文件</h3>
        <div v-if="fileList" class="doc-conten">
          <div
            class="doc-item text-14px leading-16px"
            v-for="(item, index) in fileList"
            :key="index"
          >
            <el-tooltip
              :content="`${item.fileNameOrigin}[${item.documentName}]`"
              placement="top"
              :open-delay="1000"
            >
              <p>{{ item.fileNameOrigin }}[{{ item.documentName }}]</p>
            </el-tooltip>
            <div class="opr-box">
              <!-- <el-button size="mini" @click="watchOriginFile(item, 1)">查看</el-button> -->
              <el-button size="mini" @click="viewMore(item)">查看</el-button>
              <el-button size="mini" @click="watchOriginFile(item, 2)">下载</el-button>
            </div>
          </div>
        </div>
        <h3 class="font-bold text-14px">关联文件</h3>
        <div v-if="relationFileList" class="doc-conten">
          <div class="doc-item text-13px" v-for="(item, index) in relationFileList" :key="index">
            <el-tooltip
              :content="`${item.fileName}[${item.documentName}]`"
              placement="top"
              :open-delay="1000"
            >
              <p>{{ item.fileName }}[{{ item.documentName }}]</p>
            </el-tooltip>
            <div class="opr-box">
              <el-button
                @click="viewMore(item)"
                size="mini"
                v-if="_.split(item.fileName, '.')[1] !== 'pr'"
                >预览</el-button
              >
              <!-- <el-button @click="splitScreen(item)" size="mini">分屏</el-button> -->
            </div>
          </div>
        </div>
      </el-tab-pane>
      <!-- 关联位号end -->
    </el-tabs>
    <!-- 新增关联关系start -->
    <el-dialog
      :close-on-click-modal="false"
      title="新增关联关系"
      :modal-append-to-body="false"
      :visible.sync="tagRelatedVisible"
      :before-close="cancelSaveRelation"
      v-dialogDrag
      width="60%"
    >
      <div class="">
        <div class="pb-10px">
          <span class="text-14px c-g3">类别：</span>
          <el-select
            v-model="createTagRelatedConditions.className"
            filterable
            clearable
            class="w-200"
            popper-class="select-tree"
            ref="docEditSelect"
            size="small"
            @clear="clearValue()"
          >
            <el-option
              :label="classDocName"
              :value="createTagRelatedConditions.className"
              hidden
            ></el-option>
            <el-tree
              :data="typeOptions"
              :props="{
                label: 'name',
                children: 'children',
              }"
              node-key="id"
              @node-click="handleDocEditTreeClick"
              highlight-current
            >
            </el-tree>
          </el-select>
          <!-- <el-cascader
            size="small"
            :options="typeOptions"
            :props="typeOptionsProps"
            v-model="createTagRelatedConditions.className"
            placeholder="请选择"
            :show-all-levels="false"
            :change-on-select="true"
            filterable
            clearable
          ></el-cascader> -->
          <el-input
            size="small"
            style="width: 200px"
            v-model.trim="createTagRelatedConditions.code"
            @keyup.native.enter="searchRelationList()"
            class="pl-10px"
            clearable
            placeholder="请输入位号的编码或名称"
          ></el-input>
          <el-button
            size="small"
            class="pl-10px iconfont icon-search ml-10px"
            type="primary"
            @click="searchRelationList()"
            >搜索</el-button
          >
        </div>
        <el-table
          highlight-current-row
          :data="relationTableData"
          v-loading="relationListLoading"
          border
          height="400px"
          @selection-change="selectionChange"
          class="w-full"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column prop="code" label="代码"></el-table-column>
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="className" label="类别"></el-table-column>
          <el-table-column prop="nameSpace" label="命名空间"></el-table-column>
        </el-table>
        <div class="pt-20px tr">
          <el-pagination
            background
            @size-change="searchRelationList()"
            @current-change="findRelationList()"
            :current-page.sync="relationPage.pageNo"
            :page-size.sync="relationPage.pageSize"
            :page-sizes="$pageSizeAll"
            :pager-count="5"
            layout="->, total, sizes, prev, pager, next"
            :total="relationPage.pageTotal"
          ></el-pagination>
        </div>
        <div slot="footer" class="dialog-footer text-center pt-20px">
          <el-button size="small" @click="cancelSaveRelation()">取消</el-button>
          <el-button size="small" type="primary" @click="saveRelation()">保存</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 新增关联关系end -->
    <!-- 文件查看 -->
    <el-dialog
      v-if="centerDialogVisible"
      :title="`${previewFileName}`"
      top="4vh"
      width="80%"
      :visible.sync="centerDialogVisible"
      :modal-append-to-body="false"
      center
      v-dialogDrag
    >
      <!-- svg通过iframe预览 -->
      <iframe
        v-if="previewSvgType === 'svg'"
        :src="svgUrl"
        width="100%"
        height="740px"
        class="myiframe"
        allowfullscreen
      ></iframe>
      <!-- 文件预览【kkfileview微服务预览】 -->
      <div v-else class="w-full h-740px" id="implementationFile"></div>

      <!-- <p v-if="previewSvgType === 'pdf'" class="height-20 text-14px has-text-right text-color-blue">
        操作提示：Ctrl + 鼠标滚轮中键 可放大缩小
      </p> -->
      <!-- <img
        :src="previewVersionTag === 0 ? 'static/img/gz/在用.png' : 'static/img/gz/弃用.png'"
        alt
        v-if="versionManagement === 'true'"
        class="position-absolute"
        style="right: 10px; top: 65px"
      /> -->
      <!-- 图片预览 -->
      <!-- <div
        id="splitImgDom"
        class="w-full h-800px flex justify-center"
        v-if="imgTypeList.includes(previewSvgType.toLowerCase())"
      >
        <img v-move :src="resourceUrl" id="splitImg" class="h-800px" />
      </div> -->
      <!-- <iframe
        v-if="previewSvgType === 'wizdrawing' && showIframe"
        ref="htFrame"
        :src="htPage"
        width="100%"
        height="800px"
        class="myiframe"
        allowfullscreen
        @load="htLoad"
      ></iframe> -->
      <!-- pdf预览 -->
      <!-- <iframe
        v-else-if="showIframe && previewSvgType === 'pdf'"
        width="100%"
        height="800px"
        :src="`/lib/pdfjs/web/viewer.html?file=${resourceUrl}`"
        allowfullscreen
        allow="autoplay"
        class="myiframe"
      ></iframe> -->
      <!-- 其他文件预览 -->
      <!-- <iframe
        :src="resourceUrl"
        width="100%"
        height="800px"
        v-else-if="
          showIframe &&
            !['svg', 'pdf'].includes(previewSvgType) &&
            !imgTypeList.includes(previewSvgType.toLowerCase())
        "
        allowfullscreen
        allow="autoplay"
        class="myiframe"
      ></iframe> -->
    </el-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import TagService from '@/services/tags'
import ApiMixinDocumentList from '@/assets/js/api/documentList'
import stdClassListService from '@/services/stdClassListService'
import stdClassDataService from '@/services/bsApi/stdClassDataService'
import DocumentService from '@/services/DocumentService'
import DocumentManagementService from '@/services/documentManagement'
import { getFileList } from '@/api/article'
import { ERR_OK, getUrl } from '@/api/config'
import fnMixins from '@/assets/js/fnMixins'

export default {
  mixins: [fnMixins, ApiMixinDocumentList],
  name: 'docRelational',
  component: {},
  props: {
    documentId: {
      type: String,
      default: '',
    },
    fileId: {
      type: String,
      default: '',
    },
    setSemitransparent: {
      type: Boolean,
      default: false,
    },
    classId: {
      type: String,
      default: '',
    },
    standardId: {
      type: String,
      default: '',
    },
    isVersion: {
      type: String,
      default: '',
    },
    classCode: {
      type: String,
      default: '',
    },
    folderId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      docPlaceholder: '请输入位号或名称',
      treeLoading: false,
      imgTypeList: ['bmp', 'jpg', 'jpeg', 'png', 'gif', 'webp'],
      currentEnv: Wiz.GetModuleConfig('legacy-resource').currentEnv,
      activeNames: ['1', '2'], // 折叠面板默认展开的
      hideTemplateAttr: [
        {
          code: 'lianlu',
          attr: ['lujin'],
        },
      ], // 需要隐藏显示的模板属性
      relationDocPage: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      previewFileName: '',
      previewVersionTag: '',
      previewSvgType: '',
      centerDialogVisible: false,
      resourceUrl: '',
      showIframe: false,
      relationFileList: [],
      templateAttrs: 'general', // 模板属性里面的tabs默认显示项
      generalAttrSet: {}, // 模板属性切换动态数据
      templateAttrSetList: [], // 模板属性切换动态数据
      expandedKey: [],
      activeName: 'relationCode',
      tableLoading: false,
      defaultProp: {
        children: 'tagFilesList',
        label: 'name',
        isLeaf: 'leaf',
      },
      attrData: {}, // 基本属性
      fileList: [], // 实现文件列表
      correlateTreeData: [], // 关联位号的数据
      tagRelatedVisible: false, // 新增关联位号弹窗
      typeOptionsProps: {
        value: 'id',
        label: 'name',
        children: 'children',
      },
      typeOptions: [],
      createTagRelatedConditions: {
        // 新增关联关系条件搜索
        className: '',
        code: '',
      },
      relationListLoading: false,
      relationPage: {
        pageNo: 1,
        pageSize: 15,
        pageTotal: 0,
      },
      relationTableData: [],
      tagList: [], // 选中项
      currentFileId: '',
      htPage: `${window.location.origin}/static/ht/htView.html`, // ht预览页面路径
      docKeyWord: '',
      attributeList: [],
      tagClassId: '', // 上下级类别id
      classDocName: '',
      systemParams: localStorage.getItem('systemParams')
        ? JSON.parse(localStorage.getItem('systemParams'))
        : [],
      signleFileId: '',
      tableHeader: [],
      currentTag: {}, // 当前位号
      svgUrl: '', // svg预览URL
      targetId: '', // 目标查找的code
    }
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
    versionManagement() {
      const version = _.find(this.systemParams, { parameterCode: 'versionManagement' }) || {}
      return version.parameterValue
    },
    // 文件服务地址
    standardServer() {
      return Wiz.GetModuleConfig('legacy-resource')?.currentEnv?.VUE_APP_STANDARD_SERVER
    },
    // 文件预览服务地址
    filePreviewServer() {
      return Wiz.GetModuleConfig('legacy-resource')?.currentEnv?.VUE_APP_FILE_PREVIEW_SERVER
    },
  },
  watch: {
    tagRelatedVisible(bol) {
      if (bol) {
        this.searchRelationList()
      }
      this.$emit('changeIconCollapaseZindex', !bol)
    },
    centerDialogVisible(bol) {
      this.$emit('changeIconCollapaseZindex', !bol)
    },
    resourceUrl() {
      this.showIframe = false
      this.$nextTick(() => {
        this.showIframe = true
      })
    },
    documentId(newVal, oldVal) {
      // 点击分屏刷新关联信息
      if (newVal && newVal !== oldVal) {
        this.loadData(false)
      }
    },
    targetId(newVal) {
      if (newVal) {
        this.watchTargetId(newVal)
      }
    },
  },
  methods: {
    // 在svg图里查找上一个/下一个位号
    findOne(data, type) {
      data.tagId = data.businessId
      data.findType = type
      this.$emit('getModelData', {
        data,
        type: 2,
        isFromPlayer: false,
      })
    },
    // 动态获取表头
    async getDynamicTableHeaders(id) {
      if (!id || !this.standardId) return
      const res = await TagService.getDynamicTableHeaders({
        standardId: this.standardId,
        code: 'Document',
      })
      if (res && res.code === 0 && res.data) {
        this.tableHeader = res.data
        this.getDynamicTableById(id)
      } else {
        this.tableHeader = []
      }
    },
    async getDynamicTableById(id) {
      if (!id) return
      // 判断是否为历史记录浏览文档
      if (this.isVersion === '1') {
        const params = {
          maxResultCount: 999,
          skipCount: 0,
          standardId: this.standardId,
          cateCode: 'Document',
          filter: this.classCode,
          folderId: this.folderId,
          classIds: [this.classId],
          dataId: this.documentId,
        }
        const res = await DocumentManagementService.getHistoryData(params)
        if (res && res.code === 0 && res.data) {
          const dataList = res.data[0]
          Object.keys(dataList).forEach((key) => {
            let newKey = ''
            if (key.indexOf('.') > -1) newKey = key.split('.')[1]
            _.map(this.tableHeader, (item) => {
              if (newKey === `${item.columnName}`) {
                item.value = dataList[key]
              }
              return item
            })
          })
        }
      } else {
        const res = await TagService.getDynamicTableById({
          standardId: this.standardId,
          cateCode: 'Document',
          dataId: id,
        })
        if (res && res.code === 0 && res.data) {
          Object.keys(res.data).forEach((key) => {
            _.map(this.tableHeader, (item) => {
              if (key === `${item.tableName}.${item.columnName}`) {
                item.value = res.data[key]
              }
              return item
            })
          })
        }
      }
    },
    clearValue() {
      this.createTagRelatedConditions.className = ''
      this.classDocName = ''
    },
    handleDocEditTreeClick(node) {
      this.createTagRelatedConditions.className = node.id
      this.classDocName = node.name
      this.$refs.docEditSelect.blur()
    },
    // 设置模板属性显示隐藏
    setTempAttrVisible(data) {
      const newData = _.map(data, (item) => {
        const temp = _.find(this.hideTemplateAttr, { code: item.attributeTemplate.code })
        _.forEach(item.attrValueList, (attr) => {
          attr.showAttr = true
          if (temp && temp.attr.includes(attr.fieldName)) {
            attr.showAttr = false
          }
        })
        return item
      })
      return newData
    },
    // 查看、下载关联文件
    watchOriginFile(data, type) {
      data.fileType = data.fileNameOrigin.substring(data.fileNameOrigin.lastIndexOf('.'))
      const supportType = [
        '.png',
        '.jpg',
        '.jpeg',
        '.gif',
        '.bmp',
        '.tif',
        '.pr',
        '.mp4',
        '.pdf',
        '.svg',
      ]
      if (type === 1) {
        if (supportType.includes(data.fileType)) {
          const resourceUrl = `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${data.fileId}`
          // 判断是否打开
          const pageTags = this.$store.getters.pageTags
          const filterTags = _.filter(pageTags, (tag) => {
            return tag.name === 'docView' && tag.displayFullName === data.fileName
          })
          if (!_.isEmpty(filterTags)) {
            this.$router.push(filterTags[0].fullPath)
          } else {
            this.$router.push({
              path: './doc-view',
              query: {
                mainResourceUrl: resourceUrl,
                mainFileType: data.fileNameOrigin.substring(
                  data.fileNameOrigin.lastIndexOf('.') + 1
                ),
                fileId: data.fileId,
                documentId: data.documentId,
                fileName: data.nodeName,
                isPr: data.fileType.toLowerCase() === '.pr' ? 1 : 0, // 判断是否为pr文件
                title: data.fileName,
                standardId: data.standardId,
                isVersion: this.isVersion,
                classId: this.classId,
              },
            })
          }
        } else {
          this.$confirm('当前无法直接预览，是否进行下载?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => {
              axios({
                methods: 'GET',
                url: `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${data.fileId}`,
                responseType: 'blob',
              }).then((res) => {
                if (res.status !== 200) {
                  this.$message.error('下载出现错误，请重试!')
                }
                if (res.data) {
                  this.downLoadBlob({
                    name: data.fileNameOrigin,
                    type: res.data.type,
                    data: res.data,
                  })
                }
              })
            })
            .catch(() => {})
        }
      } else {
        axios({
          methods: 'GET',
          url: `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${data.fileIdOrigin}`,
          responseType: 'blob',
        }).then((res) => {
          if (res.status !== 200) {
            this.$message.error('下载出现错误，请重试!')
          }
          if (res.data) {
            this.downLoadBlob({
              name: data.fileNameOrigin,
              type: res.data.type,
              data: res.data,
            })
          }
        })
      }
    },
    // 获取预览URL
    getPreviewUrl(fileName, fileId) {
      const fileNameType = _.last(_.split(fileName, '.')) // 文件格式
      const filePreviewServerUrl = `${this.filePreviewServer}/#/file-preview`
      let url = `url=${this.standardServer}/api/std/file/kkfileview/${fileId}.${fileNameType}` // 大部分文件格式通用
      if (fileNameType === 'svg') {
        url = `url=${this.standardServer}/api/std/file/${fileId}`
      }
      const type = `type=${fileNameType}&name=resource.${fileNameType}`
      return `${filePreviewServerUrl}?${url}&${type}`
    },
    // 关联文档树结构预览
    async viewMore(data) {
      console.log(data, 'data')
      this.previewFileName = data.fileName
      this.previewVersionTag = data.versionTag
      this.previewSvgType = _.split(data.fileName, '.')[1]

      // 如果是pr模型就直接跳转新窗口查看
      if (this.previewSvgType === 'pr') {
        const prQuery = {
          documentId: data.documentId,
          title: '',
          standardId: this.standardId,
          classId: this.classId,
          isVersion: '0', // 是否是历史版本查看
          token: localStorage.getItem('authorization'),
        }
        const previewUrl = `${this.basePath}#/fullscreen/model-doc-view/index?${qs.stringify(
          prQuery
        )}`
        window.open(previewUrl, '_blank')
        // window.open(`/#/docView?documentId=${data.documentId}`)
        return
      }

      // 其他格式文件预览
      const previewUrl = this.getPreviewUrl(data.fileName, data.fileId)
      console.log(previewUrl, 'HHH')

      if (this.previewSvgType === 'svg') {
        // 先设置新的URL,再打开弹窗
        this.svgUrl = ''
        this.$nextTick(() => {
          this.svgUrl = previewUrl
          this.centerDialogVisible = true
        })
      } else {
        // 非svg文件先打开弹窗
        this.centerDialogVisible = true
        // 启动文件预览服务
        window.wujie.setupApp({
          name: 'implementationFile',
          url: previewUrl,
          el: '#implementationFile',
        })
        window.wujie.startApp({ name: 'implementationFile' })
      }
    },
    // 关联文档树结构分屏
    splitScreen(data) {
      this.$emit('splitScreen', data)
    },
    // ht加载
    htLoad() {
      const $window = this.$refs.htFrame.contentWindow
      $window.init(this.resourceUrl)
      if (this.currentEnv.VUE_APP_CURRENT_PROJECT === 'GZ') {
        setTimeout(() => {
          $window.setColorChange()
        }, 500)
        this.htTimer = setInterval(() => {
          $window.setColorChange()
        }, 8000)
      }
    },
    /* 获取关联关系左侧tab */
    // _getFileList() {
    //   const query = getUrl(this.documentId)
    //   getFileList(query)
    //     .then((res) => {
    //       if (res.data.success === ERR_OK) {
    //         _(res.data.data).forEach((item) => {
    //           item.isRemove = false
    //         })
    //         this.relationFileList = res.data.data
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err)
    //     })
    // },
    // 懒加载获取关联位号树数据
    async loadNode(node, resolve) {
      if (node.level === 0) {
        return
      }
      if (node.level > 1) {
        resolve([])
        return
      }
      let res = []
      if (node.data.isTag) {
        res = await this.getTagNodeChildByTag(node.data)
      } else {
        res = await this.getTagNodeChild(node)
      }
      resolve(res)
    },
    async getTagNodeChildByTag(data) {
      const res = await TagService.getTagNodeChildByTag(data, this.standardId)
      if (res && res.code === 0 && res.data) {
        return _.map(res.data.items, (el) => {
          return {
            ...el,
            directoryItemId: res.data.directoryItemId,
            fieldName: res.data.fieldName,
            conditionType: res.data.conditionType,
          }
        })
      }
      return []
    },
    async getTagNodeChild(node) {
      const { treeConditions } = this.getParentNodeBusinessIds(node)
      const query = {
        StandardId: this.standardId,
        keyWords: this.docKeyWord,
        directoryId: this.tagClassId,
        expansionType: 1, // 1为位号树，2为文档树
        treeConditions: treeConditions || [],
        isLoadTag: true, // 是否加载位号对象
        fileId: this.currentFileId,
        tagCode: '',
      }
      const res = await TagService.getTagTree(query)
      if (res && res.code === 0 && res.data) {
        return _.map(res.data.items, (el) => {
          return {
            ...el,
            directoryItemId: res.data.directoryItemId,
            fieldName: res.data.fieldName,
            conditionType: res.data.conditionType,
            id: el.businessId,
          }
        })
      }
      return []
    },
    /**
     * @description: 根据当前的node,拿到父级的数据
     * @param {*} node
     * @return {*}
     */
    getParentNodeBusinessIds(node) {
      if (!node) return {}
      const treeConditions = []
      const tableConditions = {}
      while (node.level >= 1) {
        const index = _.findIndex(treeConditions, (el) => {
          return el.key === node.data.directoryItemId
        })
        if (index === -1) {
          treeConditions.unshift({
            key: node.data.directoryItemId,
            value: node.data.businessId,
          })
        }
        tableConditions[node.data.fieldName] = node.data.name
        node = node.parent
      }
      return { treeConditions, tableConditions }
    },
    // 点击关联位号树
    handleNodeClick(data, centerSvg = true) {
      this.currentTag = data
      localStorage.removeItem('lastIndex')
      if (!data.isTag) return
      data.tagId = data.businessId
      data.findType = null
      this.$emit('getModelData', {
        data,
        type: 2,
        isFromPlayer: false,
        centerSvg,
      })
    },

    // 根据code查找并选中目录树节点
    async selectNodeByCode(targetId) {
      if (!targetId || !this.$refs.tree) {
        this.$message.warning('请输入有效的编码或等待树加载完成')
        return
      }
      this.treeLoading = true
      this.targetId = targetId
      const tree = this.$refs.tree
      const foundNode = await this.findNodeByCodeRecursive(tree.root, targetId)

      if (foundNode) {
        // 选中节点
        tree.setCurrentKey(foundNode.data.id)
        // 展开节点到可见
        this.expandNodeRecursive(foundNode)

        // 等待DOM更新后，滚动到选中节点
        this.$nextTick(() => {
          this.scrollToSelectedNode(targetId)
        })
      }
      this.treeLoading = false
    },

    // 滚动到选中节点
    scrollToSelectedNode(tagId) {
      if (!this.$refs.tree) return
      try {
        // 查找选中节点的DOM元素
        const selectedNode = document.querySelector(`div[tagId="${tagId}"]`)
        console.log(selectedNode, 'selectedNode')
        if (selectedNode) {
          // 获取.el-tabs__content容器
          const tabsContent = document.querySelector('.el-tabs__content')
          console.log(tabsContent, 'tabsContent')
          // 使用scrollIntoView方法滚动到节点，设置behavior为smooth可以平滑滚动
          selectedNode.scrollIntoView({
            block: 'center', // 垂直居中
            inline: 'nearest', // 水平最近
            behavior: 'smooth', // 平滑滚动
          })

          // 重点：操作.el-tabs__content的滚动条
          if (tabsContent && tabsContent.scrollHeight > tabsContent.clientHeight) {
            const nodeRect = selectedNode.getBoundingClientRect()
            const containerRect = tabsContent.getBoundingClientRect()

            // 计算需要滚动的距离
            const scrollTop =
              nodeRect.top - containerRect.top - containerRect.height / 2 + nodeRect.height / 2

            // 平滑滚动tabsContent容器
            tabsContent.scrollTo({
              top: tabsContent.scrollTop + scrollTop,
              behavior: 'smooth',
            })
          }
        }
      } catch (error) {
        console.warn('滚动到节点时出错:', error)
      }
    },

    // 递归查找节点
    async findNodeByCodeRecursive(node, targetId) {
      if (!node) return null

      // 检查当前节点
      if (node.data && node.data.id === targetId) {
        return node
      }

      // 如果是懒加载节点且有子节点未加载，先加载子节点
      if (node.level === 1 && !node.loaded && !node.loading) {
        await new Promise((resolve) => {
          this.loadNode(node, (children) => {
            if (children && children.length > 0) {
              node.data.tagFilesList = children
              node.loaded = true
              node.childNodes = node.createChildNodes(children)
            }
            resolve()
          })
        })
      }

      // 递归查找子节点
      if (node.childNodes && node.childNodes.length > 0) {
        for (let i = 0; i < node.childNodes.length; i++) {
          const found = await this.findNodeByCodeRecursive(node.childNodes[i], targetId)
          if (found) return found
        }
      }

      return null
    },

    // 递归展开节点到可见
    expandNodeRecursive(node) {
      if (node && node.parent && node.parent.level >= 0) {
        // 使用Element UI提供的expandNode方法更安全可靠
        this.expandNodeRecursive(node.parent)
        // 先检查tree和store是否存在
        if (this.$refs.tree && this.$refs.tree.store && node.parent.data.id) {
          // 使用setExpandedKeys方法来展开节点
          const expandedKeys = this.$refs.tree.store.defaultCheckedKeys || []
          if (!expandedKeys.includes(node.parent.data.id)) {
            expandedKeys.push(node.parent.data.id)
            this.$refs.tree.setExpandedKeys(expandedKeys)
          }
        }
      }
    },

    // 监听外部传入的code变化
    watchTargetId(newCode) {
      if (newCode) {
        this.selectNodeByCode(newCode)
      }
    },
    async clickFileList(row) {
      // 点击实现文件列表
      // 获取实现文件旁边关联位号
      this.currentFileId = row.fileId
      // 修改当前选中fileId
      this.$emit('changeCurrentSelectedFileId', this.currentFileId)
      if (row.fileType === '.wizdrawing') {
        const fileRes = await DocumentService.findFileUrl({
          id: row.md5,
        })
        if (fileRes) {
          this.$emit('changeMainFile', {
            mainResourceUrl: fileRes,
            mainFileType: `${row.fileType}`,
            fileName: row.fileName,
            versionTag: this.attrData.versionTag,
            documentId: row.documentId,
            fileId: row.fileId,
          })
          return
        }
      }
      if (row.fileType !== '.pr') {
        const resourceUrl = `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${row.md5}`
        this.$emit('changeMainFile', {
          mainResourceUrl: resourceUrl,
          mainFileType: row.fileType,
          fileName: row.fileName,
          versionTag: this.attrData.versionTag,
          documentId: row.documentId,
          fileId: row.fileId,
        })
        return
      }
      this.$emit('changePlayerId', row.md5)
    },
    async findDocBasicAttr(needChangeFile) {
      if (!this.standardId) return
      // 获取文档基本属性
      this.getDynamicTableHeaders(this.documentId)
      const params = {
        id: this.documentId,
        standardId: this.standardId,
      }
      if (this.isVersion === '1') {
        params.isVersion = true
        params.classId = this.classId
      }
      const res = await DocumentService.findDocAttr(params)
      if (res && res.code === 0 && res.data) {
        // this.attrData = res.data
        // 链接参数没有传fileId，没有就通过documentId获取默认fileId
        this.currentFileId = !this.fileId ? res.data.defaultFileId : this.fileId
        // 获取关联位号
        this.getTagClassId()
        // this.findTagClassAssociation()
        if (needChangeFile) {
          // 获取当前文件内容
          this.findFile()
        }
        // 改变当前选中文件id
        this.$emit('changeCurrentSelectedFileId', this.currentFileId)
      }
    },
    async findFile() {
      // 获取一进入页面加载文件类型
      const res = await DocumentService.getDocumentFileType({
        fileId: this.currentFileId,
        isVersion: false,
        standardId: this.standardId,
      })
      if (res && res.code === 0 && res.data) {
        this.signleFileId = res.data.id
        this.$emit('signleFileId', res.data.id)
        // 兼容文件名包含多个.的情况
        // res.data.fileName = 'aa.xx.yy.pr'  test
        const fileTypeArr = _.split(res.data.fileName, '.')
        const fileType = fileTypeArr[fileTypeArr.length - 1]
        if (fileType === 'wizdrawing') {
          const fileRes = await DocumentService.findFileUrl({
            id: res.data.md5,
          })
          if (fileRes) {
            this.$emit('changeMainFile', {
              mainResourceUrl: fileRes,
              mainFileType: `${fileType}`,
              fileName: res.data.fileName,
              versionTag: this.attrData.versionTag,
              documentId: res.data.documentId,
              fileId: res.data.id,
              flag: this.attrData.flag,
            })
            return
          }
        }
        if (fileType !== 'pr') {
          // 如果不是模型
          const resourceUrl = `${this.currentEnv.VUE_APP_STANDARD_SERVER}/api/std/file/${res.data.fileId}`
          this.$emit('changeMainFile', {
            mainResourceUrl: resourceUrl,
            mainFileType: res.data.fileName.substring(res.data.fileNameOrigin.lastIndexOf('.') + 1),
            fileName: res.data.fileNameOrigin,
            versionTag: this.attrData.versionTag,
            documentId: res.data.documentId,
            fileId: res.data.fileId,
            flag: this.attrData.flag,
          })
          return
        }
        this.$emit('changePlayerId', {
          md5: res.data.md5,
          fileName: res.data.fileName,
        })
      }
    },
    // async findFileList() {
    //   // 获取文件列表
    //   const res = await DocumentService.findFileList({
    //     documentId: this.documentId,
    //     isUnionObsoletedocument: true,
    //   })
    //   if (res && res.success && res.data) {
    //     this.fileList = res.data
    //     console.log(this.fileList, 'fileList112233')
    //   }
    // },
    // 获取上下级类别id
    async getTagClassId() {
      const query = {
        StandardId: this.standardId,
        keyWords: this.docKeyWord,
        directoryId: '', // 类别id
        expansionType: 1, // 1为位号树，2为文档树
        treeConditions: [],
        isLoadTag: true, // 是否加载位号对象
        fileId: this.currentFileId,
        tagCode: '',
      }
      const res = await TagService.getTagTree(query)
      if (res && res.code === 0 && res.data && res.data.items) {
        _.map(res.data.items, (item) => {
          if (item.name === '类别') {
            this.tagClassId = item.businessId
            this.findTagClassAssociation()
          }
        })
      }
    },
    async findTagClassAssociation(type) {
      // 获取左边关联位号树结构数据
      const query = {
        StandardId: this.standardId,
        keyWords: this.docKeyWord,
        directoryId: this.tagClassId, // 类别id
        expansionType: 1, // 1为位号树，2为文档树
        treeConditions: [],
        isLoadTag: true, // 是否加载位号对象
        fileId: this.currentFileId,
        tagCode: '',
      }
      const res = await TagService.getTagTree(query)
      if (res && res.code === 0 && res.data) {
        this.correlateTreeData = _.map(res.data.items, (el) => {
          return {
            ...el,
            directoryItemId: res.data.directoryItemId,
            fieldName: res.data.fieldName,
            conditionType: res.data.conditionType,
            id: el.businessId,
            disabled: true,
          }
        })
        console.log(this.correlateTreeData, 'correlateTreeData')
      }
      // const res = await this.apiDocumentList({
      //   method: 'tagInfoByFile',
      //   params: {
      //     DocumentFileId: this.currentFileId,
      //     SkipCount: 0,
      //     MaxResultCount: 999,
      //     keWord: this.docKeyWord,
      //   },
      //   extra: { errorMsg: false },
      // })
      // if (res && res.code === 0) {
      //   this.correlateTreeData = res.data
      // }
      // const res = await DocumentService.findTagClassAssociation({
      //   fileId: this.currentFileId,
      //   keyword: this.docKeyWord,
      // })
      // if (res && res.code === 0 && res.data) {
      //   this.correlateTreeData = res.data
      //   if (type === 'search' && this.docKeyWord !== '') {
      //     this.expandedKey = _.map(this.correlateTreeData, (correlate) => {
      //       return correlate.id
      //     })
      //   }
      // }
    },
    dissolveRelationShip(data) {
      // 解除关联关系
      this.$confirm('该操作将解除其关联关系,请确认是否要继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const reqData = {
            tagIdList: [data.tagId],
            fileId: this.signleFileId,
          }
          const res = await DocumentService.dissolveRelationShip(reqData)
          if (res && res.code === 0 && res.data) {
            this.$message.success('解除成功')
            this.findTagClassAssociation()
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    // 新增关联位号
    addOperation() {
      this.tagRelatedVisible = true
    },
    // 获取新增关联关系类别选项
    // async getTagClassList() {
    //   const res = await DocumentService.findClassOptions({
    //     id: '',
    //   })
    //   if (res) {
    //     this.typeOptions = res
    //   }
    // },
    // 获取对象类别列表
    async getParentTypeList() {
      const parameter = {
        standard_id: this.standardId,
        data_type: 1,
        approve_status: 1, // 已发布的实体
      }
      const res = await stdClassListService.getClassList(parameter)
      if (res && res.code === 0 && res.data) {
        this.typeOptions = res.data.length > 0 ? this.listToTree(res.data) : []
      }
    },
    // 列表转树
    listToTree(list) {
      const result = list.reduce((prev, curr, i, arr) => {
        curr.children = arr.filter((v) => {
          return v.parentId === curr.id
        })
        if (
          curr.parentId === '00000000-0000-0000-0000-000000000000' ||
          curr.parentId === '' ||
          curr.parentId === null
        ) {
          prev.push(curr)
        }
        return prev
      }, [])
      return result
    },
    // 选中项
    selectionChange(val) {
      this.tagList = _.map(val, (item) => {
        return {
          TagId: item.id,
          Code: item.code,
          Identifier: '',
        }
      })
    },
    cancelSaveRelation() {
      // 取消保存关联关系
      this.relationPage = this.$options.data().relationPage
      this.createTagRelatedConditions = this.$options.data().createTagRelatedConditions
      this.relationTableData = this.$options.data().relationTableData
      this.tagList = this.$options.data().tagList
      this.tagRelatedVisible = false
    },
    async saveRelation() {
      // 保存关联关系
      if (_.isEmpty(this.tagList)) {
        this.$message.warning('请先勾选需要关联的项')
        return
      }
      const params = []
      _.map(this.tagList, (item) => {
        params.push({
          fileId: this.signleFileId,
          tagId: item.TagId,
          isManual: true,
          identifier: '',
        })
      })
      this.relationListLoading = true
      const res = await DocumentService.associateTagWithDocumentFile(params)
      this.relationListLoading = false
      if (res && res.code === 0) {
        this.$message.success('保存位号成功')
        this.findTagClassAssociation()
        this.cancelSaveRelation()
      }
    },
    searchRelationList() {
      // 搜索关联关系列表
      this.relationPage.pageNo = 1
      this.findRelationList()
    },
    async findRelationList() {
      // 获取关联关系列表
      const params = {
        maxResultCount: this.relationPage.pageSize,
        skipCount: (this.relationPage.pageNo - 1) * this.relationPage.pageSize,
        sorting: '',
        standardId: this.standardId,
        fileId: this.signleFileId,
        keywords: this.createTagRelatedConditions.code,
        classId: this.createTagRelatedConditions.className,
      }
      this.relationListLoading = true
      const res = await DocumentService.findRelationList(params)
      this.relationListLoading = false
      if (res && res.code === 0 && res.data) {
        this.relationTableData = res.data
        this.relationPage.pageTotal = res.totalCount
      }
    },
    refreshRelationDocList() {
      this.relationDocPage.pageNo = 1
      this.findRelationDocList()
    },
    // async findRelationDocList() {
    //   const res = await DocumentManagementService.getfilejoinfilelist({
    //     siteid: this.currentProject.id,
    //     fileid: this.currentFileId,
    //     jointype: 0, // 未关联
    //     keyword: '',
    //     pageno: this.relationDocPage.pageNo,
    //     pagesize: this.relationDocPage.pageSize,
    //   })
    //   if (res && res.code === 0 && res.data) {
    //     this.relationFileList = res.data
    //     this.relationDocPage.pageTotal = res.totalCount
    //   }
    //   console.log(res, 'res121')
    // },
    async loadData(needChangeFile = true) {
      // this._getFileList()
      // const res = await DocumentManagementService.getDocumentEdite({
      //   id: this.documentId,
      // })
      // if (res && res.code === 0 && res.data) {
      //   this.templateAttrSetList = this.setTempAttrVisible(res.data.templateAttrSetList)
      //   this.generalAttrSet = res.data.generalAttrSet
      //   // 获取默认展开的折叠面板
      //   if (this.templateAttrSetList) {
      //     _.forEach(this.templateAttrSetList, (val, index) => {
      //       this.activeNames.push(String(index + 3))
      //     })
      //   }
      // }
      // console.log(res, '559988')
      // 获取文档基本属性
      await this.findDocBasicAttr(needChangeFile)
      await this.getDocumentGeneralTemp()
      // 获取实现文件列表
      // await this.findFileList()
      await this.getRealizeFile()
      // 获取关联文档
      // await this.findRelationDocList()
      await this.getFileReleFileList()
      // 获取新增关联关系类别选项
      // this.getTagClassList()
      this.getParentTypeList()
    },
    // 获取关联文件
    async getFileReleFileList() {
      const res = await DocumentManagementService.getFileReleFileList({
        standardId: this.standardId,
        sourceTagId: this.currentFileId,
        keywords: '',
        skipCount: 0,
        maxResultCount: 999,
        Sorting: '',
      })
      if (res && res.code === 0) {
        this.relationFileList = res.data
      }
    },
    // 获取实现文件
    async getRealizeFile() {
      if (!this.standardId) return
      const params = {
        id: this.documentId,
        standardId: this.standardId,
      }
      if (this.isVersion === '1') {
        params.isVersion = true
        params.classId = this.classId
      }
      const res = await DocumentManagementService.getFileList(params)
      if (res.length > 0) {
        this.fileList = res
      } else {
        this.fileList = []
      }
    },
    // 获取文档通用属性
    async getDocumentGeneralTemp() {
      if (!this.classId) return
      const parameter = {
        classId: this.classId,
        dataId: this.documentId,
      }
      const res = await stdClassDataService.getDataById(parameter)
      if (res && res.code === 0 && res.data) {
        this.attributeList = res.data.attributeList
        this.attributeList.forEach((item) => {
          if (item.columnName === 'approve_status') {
            item.valueType = 1
            item.value =
              item.value === '0'
                ? this.$t('unreleased')
                : item.value === '1'
                ? this.$t('auditing')
                : item.value === '2'
                ? this.$t('handedOver')
                : this.$t('canceled')
          }
          if (item.value && item.value.endsWith(',')) {
            item.value = item.value.split(',')
            item.value.pop()
          }
        })
      }
    },
    async getCodeCount() {
      const currentFileId = this.$route.query.defaultFileId
      const res = await DocumentService.getCodeCount({
        documentFileId: currentFileId
      })
      if (res.code === 0 && res.data) {
        this.docPlaceholder = `${this.docPlaceholder}(${res.data.total})`
      }
      console.log(res, 'fileId-11')
    }
  },
  created() {
    this.classDocName = ''
    if (this.documentId) {
      this.loadData()
    }
    this.getCodeCount() // 获取当前文件关联位号数量
  },
  beforeDestroy() {},
}
</script>
<style lang="scss" scoped>

.doc-conten {
  .doc-item {
    padding: 2px 2px 2px 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    p {
      flex: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .opr-box {
      display: flex;
      flex-direction: row;
    }
  }
}
/deep/.el-table {
  overflow-y: auto;
}
/deep/.el-table::before,
/deep/.el-table--group::after,
/deep/.el-table--border::after {
  background: transparent !important;
}
/deep/.el-button--small {
  span {
    margin-left: 5px;
  }
}
/deep/.el-tabs__content {
  height: calc(100% - 40px);
  overflow-y: auto;
  padding-right: 20px;
}
/deep/.el-tabs__item {
  font-size: 12px;
  // &::before {
  //   display: block;
  //   content: '';
  //   width: 4px;
  //   height: 16px;
  //   background: #1890ff;
  //   position: absolute;
  //   left: 0;
  //   top: 13px;
  // }
}
#docRelational {
  width: 400px;
  height: 424px;
  left: 20px;
  top: 75px;
  z-index: 2000;
  box-shadow: 0px 0px 1px 4px #dcdbdb91;
  border-radius: 4px;
}
/deep/.el-form-item__label {
  font-weight: bold;
  font-size: 12px !important;
  color: #000 !important;
}
/deep/.el-dialog__header {
  text-align: left !important;
  font-size: 14px !important;
  font-weight: bold !important;
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
}
/deep/.el-collapse-item__header {
  border-bottom: 0 !important;
}
/deep/.el-collapse {
  border-top: 0 !important;
}
/deep/.el-collapse-item__wrap {
  border-bottom: 0 !important;
}
/deep/.el-collapse-item__header {
  font-weight: bold !important;
}
/deep/.el-collapse-item__content {
  padding-bottom: 0 !important;
  p {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.w-200 {
  width: 200px;
}

</style>
